import axios from 'axios';
import { loginreq, req } from './axiosFun';
const rsurla = 'http://192.168.110.6:8986';
// 登录接口
export const login = (params) => { return loginreq("post", rsurla+"/login", params) };

export const captcha = (params) => { return loginreq("get", "/api/login/captcha", params) };
// 获取用户菜单
export const menu = (params) => { return axios.get("/api/menu?&token=" + localStorage.getItem('logintoken')).then(res => res.data) };
// 退出接口
export const loginout = () => { return axios.delete("/api/login/out/?token=" + localStorage.getItem('logintoken')).then(res => res.data) };
// 检测登录状态
export const checklogin = () => { return axios.get("/api/login/checklogin/?token=" + localStorage.getItem('logintoken')).then(res => res.data) };
// 修改密码
export const editPasswd = (params) => { return req('post', '/api/index/editPasswd', params)};



// WEBPACK FOOTER //
// ./src/api/userMG.js